import "./overloads";

import initData from './data/init-data';
import initCameraLimits from './data/init-camera-limits';
import LayersManager from './layers/LayersManager';
import LivelabelManager from "./labels/live/livelabel-manager";
import LivelabelManagerOld from "./labels/live/livelabel-manager-old";
import MaterialBuilder from './rendering/material-builder';
import Utils from "./utils";
import AssessmentManager from "./assessment/assessment-manager";
import QuizManager from "./quizes/quiz-manager";
import AssetDeserializer from './assets/asset-deserializer';
import LivelabelConfigs from './labels/live/live-label-configs';
import ObjectManager from './objects/object-manager';
import TransformModifiers from './objects/transform-modifiers';
import Analytics from './analytics';
import s3Url from "../../configs/s3url"
import RenderManager from './rendering/render-manager';
import addNumberLabels from './labels/numbers/addNumberLabels';
import MeshIsolation from './animations/meshIsolation';
import addAnimation from './slides/animation/addAnimation';
import updateCamera from './camera/updateCamera';
import getBrowserCapabilities from "./utils/capabilites/check-browser";
import initSubtitles from "./subtitles/initSubtitles";
import initAudio from "./audio/initAudio";
import CooboAudio from "./audio/cooboAudio";
import Input from "./interactivity/inputs";
import highlightObject from "./interactivity/highlighting";
import Network from "./miniviews/network";
import ConnectedComponentContext from "./geometry/connected-components";
import setScene from "./scene/setScene";
import resize from "./utils/resize";
import getRelativeCoordinates from "./utils/get-relative-coordinates";
import FBXLoader from "./loaders/fbx-loader";
import initMaterial from "./utils/init-material";
import Splash from "./splash/splash";
import setDefinedWordsColor from "./utils/definition-style";
import SlideManager from "./utils/slide-manager";
import initTextureUsers from "./utils/texture-users";
import initObjectUsers from "./utils/object-users";
import initDragDrop2dQuizObjectDisposal from "./utils/drag-drop-2d-quiz-object-disposal";
import getPersistentUrl from "./utils/persistent-path";
import SystemDefaults from "./system-defaults";
import RenderLoop from "./utils/render-loop";
import DragDrop2DElements from './2DDragDrop/drag-drop-2d-elements.js';
import Keymap from "./utils/keyMap";
import AssetLibrary from "./assets/asset-library";
import RewardScreens from "./rewardScreens/rewardScreens";

import { ICON_SHAPE, HotspotSpriteMaterial, HotspotMesh, IconCanvas } from "./assets/sprites/IconTexture";
import { addProtection, addPostProtection } from "./utils/add-protection";
import { getMeshUnderMouse, meshRaycaster } from "./interactivity/add-interactivity";
import { MaterialTypes_T, applyMaterialParameters } from "./assets/deserialize-material";

import TerrainCar from "./terrainCar/terrainCar";
import Atom from "./chemistry/atom";
import Molecule from "./chemistry/molecule";
import MolecularMesh from "./chemistry/molecular-mesh";
import Star from "./objects/star/star";
import Water from "./objects/water";
import ScalpelPlane from "./objects/scalpel-plane";
import ProceduralObject from "./objects/procedural/procedural-object";
import MeanMedianMode from "./meanMedianMode/meanMedianMode";
import CoilEmField from "./coilEmField/coilEmField";
import FerrisWheel from "./objects/ferris-wheel";
import Racetrack from "./objects/racetrack";
import { addTeachingCylinder } from "./geometry-teaching/interactable-geometry";

import * as EnvLight from './utils/env-light';
import * as Events from "./utils/events";
import * as Supplements from "./utils/supplements";

import pako from "pako";
import resetObjectPosition from "./utils/reset-object-positions";
import LimitManager from "./interactivity/limit-manager";
import viewAll from "../editor/helpers/view-all";
import { BSON } from "../libs/bsonfy";
// import SplashVideo from "./splash/splash-video";
import addSlideControls, { removeSlideControls } from "./slides/add-slide-controls";
import { loadMeshGeometry } from './assets/deserialize-geometry';
import { getTextureUrl } from './assets/deserialize-texture';
import Q3DataStructure from "./data/q3-data-structure";
import findVisibleSlide from "./utils/find-visible-slide";
import getSlideNumber from "./utils/get-slide-number";
import CameraTweenTrack from "./camera/camera-tween-track";
import * as SyncSlide from "./utils/sync-slide";
import fixJSON from "./utils/fix-json";
import applyDifferentialSlidesAnimation from "./utils/differential-slides";
import defaultLang from "./lang";
import initDataEvents from "./data-events/data-events-coobo.js";

window.COOBO = window.COOBO || Utils.queryParams.has("coobo");

const labels = {
    configs: null,
    live: null
};

const Icon = Object.freeze({ ICON_SHAPE, HotspotSpriteMaterial, HotspotMesh, IconCanvas });

async function parseQ3ResponseData({ response, format }) {
    async function parseBinary() {
        const contentArrayBuffer = await response.arrayBuffer();
        const contentUnzipped = format === "zbson" ? pako.inflate(contentArrayBuffer) : contentArrayBuffer;
        const contentArray = new Uint8Array(contentUnzipped);

        const bsonData = BSON.deserialize(contentArray);

        return bsonData;
    }

    const content = await (format === "json" ? response.json() : parseBinary());
    const size = JSON.stringify(content).length;

    return Object.freeze({ content, size });
}

async function fetchQ3Data({ fetchUri, format, ignoreFormatParam}) {
    const url = new URL(fetchUri, window.COOBO ? "https://coobo.embibe.com" : window.location.origin);
    const searchParams = url.searchParams;
    const headers = {};

    switch (format) {
        case "bson":
            if (!ignoreFormatParam) {
                searchParams.append("format", "bson");
            }
            headers["Content-Type"] = "application/octet-stream";
            break;
        case "zbson":
            if (!ignoreFormatParam) {
                searchParams.append("format", "zbson");
            }
            headers["Content-Type"] = "application/octet-stream";
            break;
        case "json":
        default:
            if (!ignoreFormatParam) {
                searchParams.append("format", "json");
            }
            headers["Content-Type"] = "application/json";
            format = "json";
            break;
    }

    const response = await fetch(url, { method: "GET", headers: headers });

    return await parseQ3ResponseData({ response, format });
}

function checkDeltas(slideIndex = Q3.SlideManager.activeSlide) {
    const dtTarget = Q3.controls.target.clone().sub(Q3.SlideManager.getSlide(slideIndex).camera.target);
    const dtPosition = Q3.RenderManager.activeCamera.position.clone().sub(Q3.SlideManager.getSlide(slideIndex).camera.position);

    return { position: dtPosition.length(), target: dtTarget.length() };
}

export { AssessmentManager, QuizManager, Analytics, RenderManager, EnvLight, Events, Keymap };
export { AssetLibrary as assets, AssetLibrary, AssetDeserializer };
export { MaterialBuilder, MeshIsolation, Supplements, Input, Network, SlideManager, LimitManager };
export { ConnectedComponentContext, Icon, SystemDefaults };
export { ObjectManager, TransformModifiers, s3Url, addNumberLabels, addAnimation, labels };
export { highlightObject, getRelativeCoordinates, getMeshUnderMouse, meshRaycaster, resize };
export { FBXLoader, CooboAudio, RenderLoop, DragDrop2DElements };
export { initMaterial, getPersistentUrl, fetchQ3Data, parseQ3ResponseData, resetObjectPosition };
export { checkDeltas, viewAll, CameraTweenTrack };
export { MaterialTypes_T, applyMaterialParameters };
export { Atom, Molecule, MolecularMesh, Star, Water, ScalpelPlane, ProceduralObject };
export { TerrainCar, MeanMedianMode, CoilEmField, FerrisWheel, Racetrack, addTeachingCylinder };
export { loadMeshGeometry, getTextureUrl, removeSlideControls };
export { SyncSlide };

function fixJSONData(data) {
    if (typeof data === "string") {
        data = JSON.parse(data);
        $("#splash-tour-name").html(data.title);
    }

    return fixJSON(data);
}

let tourLoading = false;

export async function loadTour(tourId, slideUuid) {
    if (tourLoading) return;

    tourLoading = true;
    RenderManager.pause();

    try {
        if (Q3.editMode) throw new Error("Functionality not available in edit mode.");

        let data;

        if (tourId) {
            const response = await fetch(`${(window.COOBO ? "/api" : "")}/demo/${tourId}`);

            if (!response.ok) throw new Error("Could not find tour:", tourId);

            data = await response.json();
        } else data = new Q3DataStructure();

        data = fixJSONData(data);

        if (data.setups.differentialSlidesAnimation)
            data.slides = applyDifferentialSlidesAnimation(data.slides);

        Q3.isReady = false;
        Q3.isFullyLoaded = false;

        const cache = new WeakMap();

        function disposeProps(obj) {
            if (cache.has(obj)) return;

            if (typeof obj === "object")
                cache.set(obj, true);

            if (obj instanceof Array) {
                obj.forEach(obj => disposeProps(obj));
                return;
            }

            Object.keys(obj).forEach(key => {
                if (key === "parent") return;

                const prop = obj[key];

                if (prop && typeof prop === "object")
                    disposeProps(prop);
            });

            if (obj.dispose && typeof obj.dispose === "function") {
                obj.dispose();
                console.log("Disposing", obj);
            }
        }

        cache.set(RenderManager.activeScene, true);

        let disposable;
        while (disposable = RenderManager.activeScene.children.pop()) {
            disposeProps(disposable);
        }

        disposeProps(AssetLibrary.textures);
        disposeProps(AssetLibrary.geometries);

        RenderManager.raycaster.clearTracker();
        RenderManager.raycaster.clear();
        Q3.labels.live.clear();
        AssetLibrary.clear();
        SlideManager.reset();
        removeSlideControls();

        RenderManager.background.setBackground({ type: "none", tweenTime: 0 });
        RenderManager.mainRenderer.clear();

        Q3.data = initData(data, Q3.nouicontrols); //Initializes default values when properties are empties.
        initDataEvents();
        Q3.cooboLang = Q3.data.setups.cooboLang || "english";
        Q3.language = Q3.data.setups.language || localStorage.getItem("locale") || defaultLang;

        const slideNumber = getSlideNumber(data, slideUuid);
        if (slideNumber !== false) SlideManager.activeSlide = slideNumber;
        else SlideManager.activeSlide = Q3.editMode ? 0 : findVisibleSlide();

        const onAssetLoadCallback = p => {
            // progressBar.width(p * 100 + "%");
            if (p >= 1) {
                // progressBar.fadeOut();
                Q3.isFullyLoaded = true;
                Q3.isReady = true;
                // Analytics.loadingTime = (new Date() - window.loadingStart) + "ms";
                RenderManager.setHighlightObjects();

                SlideManager.setSlide(SlideManager.activeSlide, { force: true, noAnimation: true });
                resize();
                RenderManager.activeCamera.update = true;

                removeSlideControls();
                addSlideControls();
                Events.fire("update_size_display");
                Events.fire("commit_slide", {
                    noAnimation: true, onReady: function () {
                        tourLoading = false;
                        RenderManager.resume();
                    }
                });
            }
        };

        AssetDeserializer.load({
            data: Q3.data,
            browserCapabilities: Q3.browserCapabilities,
            backgroundContainer: Q3.container,
            curSlide: SlideManager.activeSlide,
            isEditMode: Q3.editMode,
            isPreviewMode: Q3.inPreviewMode
        }).then(onAssetLoadCallback);

        addAnimation();
        RewardScreens.init();
        $("#total-slide-count").html(Q3.data.slides.length);
    } catch (e) {
        tourLoading = false;
        throw e;
    }
}

export async function start(elementId, data, editorMode, errorCallback, LimitsCtl) {
    const loadTime = new Date() - window.performance.timing.navigationStart;

    console.log(`Time to initialization: ${loadTime / 1000}`);

    data = data || new Q3DataStructure();
    if (data.setups.differentialSlidesAnimation) {
        data.slides = applyDifferentialSlidesAnimation(data.slides);
    }
    data = fixJSONData(data);

    // if (!editorMode) await SplashVideo.init();

    const assetMode = window.location.pathname.match(/\/(view|edit_hierarchy|edit)_(asset|translation)\//);
    Q3.assetMode = assetMode ? assetMode[1] : false;
    Q3.isAssetMode = !!assetMode;

    Q3.browserCapabilities = await getBrowserCapabilities({
        canTestGPU: Utils.queryParams.has("test_gpu"),
        editorMode,
        assetEditMode: Q3.isAssetMode && Q3.assetMode === "edit"
    });

    addProtection();

    Q3.isReady = false;
    Q3.mediaIsPlaying = [];
    Q3.inPreviewMode = !!window.location.href.match(/\/view(_asset)?\/preview/);
    Q3.data = {}; //the empty JSON, before init with 'start'
    initDataEvents();
    Q3.teachMode = Utils.queryParams.has("is-teacher") ? "teacher" : Utils.queryParams.has("is-student") ? "student" : false;
    let resumeTimestamp = parseFloat(Utils.queryParams.get("resume_timestamp"));
    Q3.resumeTimestamp = !isNaN(resumeTimestamp) ? resumeTimestamp : null;
    function getSlideNumberFromQueryParam(data) {
        if (!Utils.queryParams.has("slide")) return false;

        const slideUuid = Utils.queryParams.get("slide");

        return getSlideNumber(data, slideUuid);
    }

    const slideNumber = getSlideNumberFromQueryParam(data);
    if (slideNumber !== false) SlideManager.activeSlide = slideNumber;
    else SlideManager.activeSlide = 0;

    Q3.isTransitioning = false;
    Q3.editMode = !!editorMode;

    if (!Q3.editMode && !Q3.isAssetMode) {
        delete data.assets.references;
        Object.keys(data.assets).forEach((type) => {
            let assetsOfType = data.assets[type];
            Object.keys(assetsOfType).forEach((key) => {
                let asset = assetsOfType[key];
                delete asset.isReference;
                delete asset.referenceId;
            })
        });
    }

    if (Q3.browserCapabilities.isMobile) { document.body.classList.add("is-mobile"); }
    if (Q3.browserCapabilities.isSafari) { document.body.classList.add("is-safari"); }
    if (data.setups.theme) { document.body.classList.remove(window.defaultQ3Theme); document.body.classList.add(data.setups.theme); }

    labels.configs = new LivelabelConfigs();
    if (Utils.queryParams.has('live_label_layouts')) {
        labels.live = new LivelabelManager({ configs: Q3.labels.configs });
    } else {
        labels.live = new LivelabelManagerOld({ configs: Q3.labels.configs });
    }

    Q3.data = initData(data, Q3.nouicontrols); //Initializes default values when properties are empties.
    initDataEvents();
    Q3.cooboLang = Q3.data.setups.cooboLang || "english";
    Q3.language = Q3.data.setups.language || localStorage.getItem("locale") || defaultLang;
    initAudio();
    initTextureUsers();
    initObjectUsers();
    initDragDrop2dQuizObjectDisposal();
    if (!Q3.editMode) {
        initSubtitles();
    }

    //The method pop() puts its CB inside a settimeout 0 so that
    //we are sure that even on mobile, the splash has been set
    //when we start doing intensive CPU stuff

    Q3.container = Q3.container || document.getElementById(elementId);
    Q3.letterbox = document.getElementById("slide-layers-letterbox");

    if (Q3.letterbox && Utils.queryParams.has("debug_letterbox")) {
        Q3.letterbox.style.backgroundColor = "rgba(255, 0, 0, 0.5)";
    }

    Splash.pop("viewer", () => {

        /* svg overlay */
        let progressBar = $("<div id='mobile-progressbar'></div>");
        if (!Q3.nouicontrols) $("body").append(progressBar);

        const onAssetLoadCallback = p => {
            if (Utils.queryParams.get("callouts") === "true") {
                Q3.data.slides[0].background.type = "none";
            }
            progressBar.width(p * 100 + "%");
            if (p >= 1) {
                progressBar.fadeOut();
                Q3.isFullyLoaded = true;
                Analytics.loadingTime = (new Date() - window.loadingStart) + "ms";
                RenderManager.setHighlightObjects();
            }
        };

        AssetDeserializer.load({
            data: Q3.data,
            browserCapabilities: Q3.browserCapabilities,
            backgroundContainer: Q3.container,
            curSlide: SlideManager.activeSlide,
            isEditMode: Q3.editMode,
            isPreviewMode: Q3.inPreviewMode,
            errorCallback,
        }).then(onAssetLoadCallback);

        setScene(editorMode, LimitsCtl);

        {
            let color = ((data.setups.objects2d || {}).text || {}).definitionColor;
            if (color) {
                setDefinedWordsColor("#" + new THREE.Color(Number(color)).getHexString());
            }
        }

        Q3.layers = LayersManager.init(Q3.data);
        Events.fire('layersready');

        Q3.container.appendChild(Q3.controls.autoCenterHelper);

        if (perfDebug) document.body.appendChild(stats.domElement);

        updateCamera(); //adds camera
        addAnimation();

        initCameraLimits({ data: Q3.data, controls: { orbit: Q3.physicalCameraControls, FPS: Q3.FPSControls, objectRotation: Q3.objectRotationControls } });

        addPostProtection();
    });
}
